module.exports = __webpack_public_path__ + "static/media/bariatirc-surgery-icon@3x.7de3c9c8.png";